import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid } from "@mui/material";
import { MAIN_COLOR } from "../common/sharedFunctions";
import { useSelector } from "react-redux";
import { colors } from "./Theme/WebTheme";

function CircularLoading() {
  const auth = useSelector((state) => state.auth);

  const color =
    auth.profile?.usertype === "rider"
      ? colors.RIDER_MAIN
      : auth.profile?.usertype === "driver"
      ? colors.DRIVER_MAIN
      : MAIN_COLOR;

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent={"center"}
      style={{ minHeight: "100vh" }}
    >
      <CircularProgress style={{ color }} />
    </Grid>
  );
}

export default CircularLoading;
